import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/loader/styles.scss';export default {
  "allocations": "_allocations_1xvvy_1",
  "even": "_even_1xvvy_5"
};